/** Format a whole-number rate (0–100) from the API as a display percent. */
export function formatPercentRate(rate: number): string {
  return `${rate}%`;
}

/** Prefer UTM source, then referrer, for grouped source rows. */
export function formatTrafficSource(utmSource: string | null, referrer: string | null): string {
  const trimmedUtm = utmSource?.trim();
  if (trimmedUtm) return trimmedUtm;
  const trimmedReferrer = referrer?.trim();
  if (trimmedReferrer) return trimmedReferrer;
  return '—';
}
